import { Col, Form, Input, Row, Select, Button, notification, Switch } from 'antd';
import {
  CheckOutlined,
  CloseOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
} from '@ant-design/icons';
import { useHistory, useParams } from 'react-router-dom';
import { UserService } from '../../sdk';
import { Usuarios } from '../../sdk/@types/Usuarios';
import jwtDecode from 'jwt-decode';
import { Authentication } from '../../auth/Auth';
import { userInfo } from 'os';
import { useCallback, useEffect, useMemo, useState } from 'react';
import LojaService from '../../sdk/services/Loja.service';
import { Lojas } from '../../sdk/@types/Restaurantes';
import MaskedInput from 'antd-mask-input';
import { Option } from 'antd/lib/mentions';

const { TextArea } = Input;


export default function FormularioTerminalComercial(props: {
  onSuccess: () => any;
  terminalComercial?: any;
  terminaisFiscais: any[];
  terminaisServico: any[];
}) {


  const [data, setData] = useState<Lojas.TerminalTratado[]>();
  const access_token = localStorage.getItem('accessToken');
  const parametroUrl = useParams<{ id: string }>();
  const idLoja: number = parametroUrl.id ? parseInt(parametroUrl.id) : 0;
  const decodedToken: Authentication.AccessTokenDecodedBody = jwtDecode(
    access_token as string
  );

  const { onSuccess } = props;
  const [loading, setLoading] = useState(false);

  const history = useHistory();


  return (
    <Form
      autoComplete={'off'}
      layout={'horizontal'}
      onFinish={async (novoTerminal: any) => {
        console.log(props.terminalComercial);
        console.log(novoTerminal);

        if (props.terminalComercial) {
          var resp = await LojaService.updateTerminalComercial(novoTerminal, props.terminalComercial.id, props.terminalComercial.idLoja);
          if (resp.status == 200) {
            setLoading(false);
            onSuccess();
          }
        } else {
          //LojaService.criarTerminalComercial(novoTerminal, novoTerminal.id);
        }

      }}
      initialValues={
        props.terminalComercial
          ? {
            ...props.terminalComercial,
            tpAmb: Number(props.terminalComercial.tpAmb),
            idTerminalFiscal: (props.terminalComercial.idRefTerminalFiscal),
            idTerminalServico: (props.terminalComercial.idRefTerminalServico),
          }
          : undefined
      }
    >
      <Row align={'top'} gutter={24}>
        <Col xs={24} lg={24}>
          <Form.Item label={'Nome'} name={'nome'}>
            <Input placeholder={'E.x.: xxxxxxxx'} />
          </Form.Item>
        </Col>

        <Col xs={24} lg={24}>
          <Form.Item
            label="Ambiente"
            name="tpAmb"
            rules={[{ required: true, message: 'Selecione o ambiente.' }]}
          >
            <Select
              placeholder="Selecione o ambiente"
              options={[
                { value: 1, label: 'Produção' },
                { value: 2, label: 'Homologação' },
              ]}
            />
          </Form.Item>
        </Col>


        {/* NOVO: Select de Terminais Fiscais */}
        <Col xs={24} lg={24}>
          <Form.Item
            label={'Terminal Fiscal'}
            name={'idTerminalFiscal'}
          >
            <Select
              // onChange={onChange}
              //  onSearch={onSearch}
              //  ref={refTokenCidade}
              placeholder={"Selecione um terminal fiscal"}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option!.children as unknown as string)
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {props.terminaisFiscais.map((terminal: any) => (
                <Option value={terminal.id}>{terminal.serie}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} lg={24}>
          <Form.Item
            label={'Terminal Serviço'}
            name={'idTerminalServico'}
          >
            <Select
              // onChange={onChange}
              //  onSearch={onSearch}
              //  ref={refTokenCidade}
              placeholder={"Selecione um terminal de serviço"}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option!.children as unknown as string)
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {props.terminaisServico.map((terminal: any) => (
                <Option value={terminal.id}>{terminal.serie}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        {/* NOVO: TextArea para parâmetros (string JSON) */}
        <Col xs={24} lg={24}>
          <Form.Item
            label={'Parâmetros'}
            name={'parametros'}
            tooltip='Cole aqui uma string JSON. Ex.: {"stableFrames":3}'
            rules={[
              {
                validator: (_, value) => {
                  if (!value || value.trim() === '') return Promise.resolve();
                  try {
                    JSON.parse(value);
                    return Promise.resolve();
                  } catch {
                    return Promise.reject(
                      new Error('O texto deve ser um JSON válido.')
                    );
                  }
                },
              },
            ]}
          >
            <TextArea
              placeholder='Ex.: {"stableFrames":3,"cooldownMs":5000}'
              autoSize={{ minRows: 4, maxRows: 10 }}
              maxLength={5000}
              showCount
            />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Row justify={'end'}>
            <Button type={'primary'} htmlType={'submit'} loading={loading}>
              {'Salvar'}
            </Button>
          </Row>
        </Col>
      </Row>
    </Form >
  );
}
